import React, { useEffect } from 'react'
import { useAppSelector } from '../../../store/index.ts'
import './index.css'
import { Link, useNavigate } from 'react-router-dom'
import AdminTable from '../../../components/organism/adminTable/index.tsx'

const Dashboard : React.FC = () => {
	const { userData } = useAppSelector(({ userData }) => userData)

	const navigate = useNavigate()
	useEffect(() => {
		if (!userData) {
			navigate('/admin')
		}
	})
	return (
		<div className='dashboard-container'>
			<div className='navbar-div navbar-admin'>
				<div className='navbar-container navbar-admin'>
					<div className='navbar-items-container'>
						<Link className='navbar-container-logo' to={'/admin/dashboard'}>
							<img src={require('../../../assets/weddingCamera/logo-with-text.png')}/>
						</Link>

						{
							userData?.isSuperAdmin &&
							<Link className='' to={'/admin/dashboard/partners'}>
								<h2>Partneri</h2>
							</Link>
						}
					</div>
					<h3>
						{userData?.name}
					</h3>
				</div>
			</div>

			<div className='dashboard-content-container'>
				<AdminTable />
			</div>
		</div>
	)
}

export default Dashboard
